module.exports = __webpack_public_path__ + "static/media/pay-ahead-deactivate.4fd3374f.svg";